import { render } from "./Eventos.vue?vue&type=template&id=0e197cb0&scoped=true"
import script from "./Eventos.vue?vue&type=script&lang=js"
export * from "./Eventos.vue?vue&type=script&lang=js"

import "./Eventos.vue?vue&type=style&index=0&id=0e197cb0&lang=scss&scoped=true"

import exportComponent from "C:\\Dev\\Vue\\intensione\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e197cb0"]])

export default __exports__